<template>
<div uk-sticky="start: 200; animation: uk-animation-slide-top;show-on-up: true; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky;" class="topbar" >
  <div class="uk-container"  >
  <nav class="uk-navbar-container" uk-navbar>
      <div class="uk-navbar-left">
          <strong>CMT Enhanced Question Bank</strong>
      </div>
     
      <div class="uk-navbar-right uk-text-right">
          <span style="padding: 0px 10px;color: rgba(255,255,255,0.6);">{{firstName}} {{lastName}}</span>&nbsp;<span style="color: rgba(255,255,255,0.4);">•</span>&nbsp;
          <a style="padding:  0px 10px; color: rgba(255,255,255,0.8); text-decoration: underline;" href="/logout">Sign Out</a>

      </div>
  </nav>
     </div>

  </div>
</template>

<script>

export default {
  name: "GlobalHeader",

  methods: {
    updateLocale(locale) {
        this.$emit('locale-change', { newLocale: locale })

    }
  },
  computed: {
      currentLocale() {
      return this.$root.$i18n.locale;
    },
    firstName() {
      return window.firstName;
    },
    lastName() {
      return window.lastName;
    }
  }
  
    
};
</script>

<style lang="scss" scoped>
h1 {
    margin-bottom: 0.25em;
}
a.langToggle {
    margin-top: -20px;
    text-decoration: underline;
    font-size: 90%;
    color: #5b489e;
}
</style>
